import apiClient from "../config/apiClient";


export const fetchLabourHistory = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=patient/labour-managements?page=1&limit=12&patient_id=${id}&startDate=&endDate=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  